import {
  Component,
  EventEmitter,
  Input,
  input,
  Output,
  Type,
  // viewChild,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RoleDisplayPipe } from '../../pipes/role-display.pipe';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
// import { SidebarLinksModel } from '../sidebar/sidebarLinks.model';
// import { CapellaLogoComponent } from "";
interface SidebarLinksModel {
  id: number;
  name: string;
  url: string;
  iconPath?: Type<any>;
  imgUrl?: string;
}
@Component({
  selector: 'stc-apps-navigation-sidebar',
  standalone: true,
  imports: [RoleDisplayPipe, CommonModule, RouterModule, TooltipModule],
  templateUrl: './navigation-sidebar.component.html',
  styleUrl: './navigation-sidebar.component.scss',
})
export class NavigationSidebarComponent {
  @Input() isSidebarExpanded = false;
  @Output() toggleMenu = new EventEmitter<boolean>();
  @Output() logout = new EventEmitter<boolean>();
  sidebarLinks = input.required<SidebarLinksModel[]>();
  username = input.required<string>();
  userRole = input.required<string>();
  generateAvatarFromUserName() {
    if (!this.username()?.trim()) {
      return '';
    }
    const names = this.username().trim().split(/\s+/);
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }
    return (
      names[0].charAt(0) + names[names.length - 1].charAt(0)
    ).toUpperCase();
  }
  constructor(private sanitizer: DomSanitizer) {}

  getSvg(svg: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }
  // private router = inject(Router);
  // private routerEvent = toSignal(this.router.events);
  // private sideNavLinks = viewChild<PanelMenu>("sideNavLinks");
  // isSidebarExpanded: ModelSignal<boolean> = model<boolean>(false);
  // isDesktopView = input<boolean>(false);
  // @Output() toggleMenu = new EventEmitter<void>();
  // activeRoute: Signal<string> = computed(() => {
  //   if (this.routerEvent() instanceof NavigationEnd) {
  //     return (this.routerEvent() as NavigationEnd).urlAfterRedirects?.split(
  //       "?",
  //     )[0];
  //   }
  //   return this.router.url?.split("?")[0];
  // });
  // constructor() {
  //   effect(() => {
  //     if (!this.isSidebarExpanded()) {
  //       this.sideNavLinks()?.collapseAll();
  //     }
  //   });
  // }
  // setNavigationLinksBasedOnUserRole(userRoles: string[]) {
  // }
  // onMenuToggle() {
  //   this.isSidebarExpanded.update((expanded) => !expanded);
  // }
  // toggleExpandLinkItems(link: CustomMenuItem) {
  //   if (!link["route"] && link.items) {
  //     this.isSidebarExpanded.set(true);
  //   }
  // }
  toggleSidebar() {
    this.isSidebarExpanded = !this.isSidebarExpanded;
    this.toggleMenu.emit(this.isSidebarExpanded);
  }
  logoutFun() {
    this.logout.emit();
  }
}
